import { IsString } from "class-validator";

export class PatientAppHkidValidateDTO {
    @IsString()
    hkid: string;
}1